// extracted by mini-css-extract-plugin
export var boxItems = "_bv-1";
export var boxItemsLg = "_bv-2";
export var button = "_bv-7";
export var buttonLg = "_bv-8";
export var filterGroupBox = "_bv-0";
export var icon = "_bv-3";
export var iconSecondary = "_bv-6";
export var iconWrapper = "_bv-4";
export var iconWrapperLg = "_bv-5";